import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ExecutionState } from '../../../assets/data/enum/executionState';
import { ThemeConfig } from '../../../assets/data/enum/themeConfig';

export class messageAlert {
  title: string;
  subtitle: string;
}

@Injectable({
  providedIn: 'root',
})
export class OperationStateService {
  showOperationInProgress$: BehaviorSubject<ExecutionState> = new BehaviorSubject<ExecutionState>(
    ExecutionState.nostate
  );
  showOperationAlert$: BehaviorSubject<messageAlert> = new BehaviorSubject<messageAlert>({
    title: '',
    subtitle: '',
  });
  enabledMessageAlertAPI$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  themeConfig = ThemeConfig;

  setBarMessage(title: string, subtitle: string): void {
    this.showOperationAlert$.next({ title, subtitle });
  }

  getStateOperation() {
    return this.showOperationInProgress$;
  }

  getLanguage(): string {
    // Implementazione della logica per ottenere la lingua dal browser
    return navigator.language || 'en';
  }

  getBarMessage() {
    return this.showOperationAlert$;
  }
}
